/**
 * Dashboard layout wrapper – sidebar + content area.
 * Uses React Router <Outlet /> for nested route rendering.
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

export default function DashboardLayout() {
  return (
    <div className="dash-layout">
      <Sidebar />
      <main className="dash-content">
        <Outlet />
      </main>
    </div>
  );
}
